import React from 'react';

type IconProps = {
    color?: string;
    width?: number;
    height?: number;
};

const IconInformation: React.FC<IconProps> = ({ color = '#505050', width = 17, height = 17 }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="fi_12125951">
                <path
                    id="Vector"
                    d="M6.99984 6.99996H7.6665V10.3333M6.99984 10.3333H8.33317M7.99984 5.33329C7.99984 5.51729 7.8505 5.66663 7.6665 5.66663C7.4825 5.66663 7.33317 5.51729 7.33317 5.33329C7.33317 5.14929 7.4825 4.99996 7.6665 4.99996C7.8505 4.99996 7.99984 5.14929 7.99984 5.33329ZM7.6665 13.6666C4.3525 13.6666 1.6665 10.9806 1.6665 7.66663C1.6665 4.35263 4.3525 1.66663 7.6665 1.66663C10.9805 1.66663 13.6665 4.35263 13.6665 7.66663C13.6665 10.9806 10.9805 13.6666 7.6665 13.6666Z"
                    stroke={color}
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
        </svg>
    );
};

export default IconInformation;
